<template>
  <div class="c-playlists-name-expand-function">
    <p class="track-id" v-if="showTrackId">
      <tooltip :label="trackNumber" width="230px" whiteSpaceWrap placement="left">
      {{ formatTrackNumber }}
    </tooltip>
    </p>
    <div class="name">
      <tooltip :label="`${versionName} ${versionDescription}`" width="230px" whiteSpaceWrap placement="left">

        <p class="name__music-name">{{ versionName }} {{ versionDescription }}</p>
      </tooltip>
      <p v-show="data.extraInfo" class="name__extra-info">({{ data.extraInfo }})</p>
    </div>
  </div>
</template>
<script>
import { defineComponent, computed } from 'vue';
import Tooltip from '@/components/Global/Tooltip.vue';
import { handleComplexTrackNumber } from '@/utils/helper';

export default defineComponent({
  name: 'VersionAndEditNameFunction',
  components: {
    Tooltip,
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    column: {
      type: Object,
      default: () => ({}),
    },
    idx: {
      type: Number,
    },
    showTrackId: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const versionName = computed(() => {
      if (props.data.editType && props.data.versionType) {
        return `${props.data.editType}/${props.data.versionType}`;
      }

      if (props.data.editType && !props.data.versionType) {
        return props.data.editType;
      }

      if (!props.data.editType && props.data.versionType) {
        return props.data.versionType;
      }

      return '';
    });

    const versionDescription = computed(() => {
      if (props.data.versionDescription) {
        return `(${props.data.versionDescription})`;
      }
      return '';
    });

    const trackNumber = computed(() => {
      if (props.data?.trackNumber) {
        return `${props.data.trackNumber}`;
      }

      if (props.data?.track?.trackNumber) {
        return `${props.data.track.trackNumber}`;
      }

      return '';
    });

    const formatTrackNumber = computed(() => {
      const tempStr = handleComplexTrackNumber(trackNumber.value);

      return tempStr;
    });

    return {
      trackNumber,
      versionName,
      versionDescription,
      formatTrackNumber,
    };
  },
});
</script>
<style lang="scss" scoped>
.c-playlists-name-expand-function {
  // width: 100%;
  @include flex();
  @include padding(0px 20px 0px 0);
  width: auto;
  max-width: 500px;
}

.name {
  flex: none;
  // width: 300px;
  width: fill-available;
  // width: 100%;
  @include flex();
  margin-left: 20px;

  &__music-name {
    @include word-ellipsis(1);
    @include font-style($c-assist6, 14, normal, 0px, 26px);
  }

  &__extra-info {
    margin-left: 5px;
    @include font-style($c-assist4, 14, normal, 0px, 26px);
  }
}

.track-id {
  @include font-style($c-assist4, 14, 400, 0.7px, 26px);
  // width: 30px;
}

@media screen and (min-width: $sm-pc) {
  .track-id {
    color: $c-black;
  }
}
</style>
